const TYPES=Object.freeze([
  ['wired','Przewodowy','Wired'],
  ['wireless','Bezprzewodowy','Wireless'],
  ['bluetooth','Bluetooth','Bluetooth'],
  ['wifi','Wi-Fi','Wi-Fi'],
  ['instant_read','Natychmiastowy odczyt','Instant-read'],
  ['other','Inny','Other']
].map(([key,pl,en])=>Object.freeze({key,labels:Object.freeze({pl,en})})));

export function thermometerTypeOptions({locale='pl'}={}){
  const lang=String(locale||'pl').toLowerCase().startsWith('en')?'en':'pl';
  return Object.freeze(TYPES.map(item=>Object.freeze({
    key:item.key,
    label:item.labels[lang]||item.labels.pl
  })));
}

export function isKnownThermometerType(value){
  const key=String(value||'').trim().toLowerCase();
  return TYPES.some(item=>item.key===key);
}
